import ParcelexApi from '../../services/parcelex';

export default {
  async preApprove({
    apiKey,
    env,
    cpf,
    phone,
    email,
    zipCode,
    trackId,
    price,
    campaign,
  }) {
    return ParcelexApi.post('/public/preApprove', {
      apiKey,
      env,
      cpf,
      phone,
      email,
      zipCode,
      source: 'site',
      trackId,
      price,
      campaign,
    });
  },
  checkUserCpf({ cpf }) {
    return ParcelexApi.post('/user/check', { cpf });
  },
  sendAccessLinkByMethod({ method, cpf }) {
    return ParcelexApi.post(`user/send/${method}`, { cpf });
  },
};
